<template>
  <div class="artical">
    <div class="title">{{detailData.postTitle}}</div>
    <div class="date">{{detailData.postDate}}</div>
    <div class="txt" v-html="detailData.postContent"></div>
  </div>
</template>

<script>
export default {
  name: "Artical",
  props: ["detailData"],
};
</script>

<style lang="less">
.artical {
  padding: 0 0.5rem;
  .title {
    font-size: 0.5rem;
    font-family: FranklinGothic-Demi;
    font-weight: 400;
    color: #2f2f2f;
    line-height: 1.5;
    font-weight: bold;
  }
  .date {
    font-size: 0.36rem;
    font-family: Open Sans;
    font-weight: 400;
    color: #333333;
    line-height: 1rem;
  }
  .txt {
    font-size: 0.4rem;
    font-family: Open Sans;
    font-weight: 400;
    // line-height: 0.7rem;
    padding: 0 0 15px 0;
    img{
      width: 100% !important;
      height:auto !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .txt {
    font-size: 0.44rem;
    font-family: Open Sans;
    font-weight: 400;
    line-height: 0.7rem;
    padding: 0 0 15px 0 !important; 
  }
}
@media screen and (min-width: 768px) {
  .detialBox {
    .artical {
      padding: 0;
    }
    .title {
      // font-size: 0.35rem;
      font-family: FranklinGothic-Demi;
      font-weight: 400;
      color: #2f2f2f;
      // line-height: 0.6rem;
      font-weight: bold;
    }
    .txt {
      font-size: 0.2rem;
      font-family: Open Sans;
      font-weight: 400;
      // line-height: 0.3rem;
      padding: 0 0 15px 0;
    }
    .date {
      font-size: 0.2rem;
      font-family: Open Sans;
      font-weight: 400;
      color: #333333;
      line-height: 0.3rem;
    }
  }
}
</style>